import React from "react";
import { node, string } from "prop-types";
import { Col, Container, Row } from "../../../Grid";
import Section from "../../../Section";
import Heading from "../../../Heading";
import Image from "../../../Image";
import Paragraph from "../../../Paragraph";
import { classes } from "../../../utils/classes";

export const IGEMSection = ({ children }) => {
	return (
		<Section spacing={{ my: 10 }}>
			<Container>
				<Row utility={{ justify: "center" }}>
					<Col sm={12} md={10} sx={{ textAlign: "center" }}>
						{children}
					</Col>
				</Row>
			</Container>
		</Section>
	);
};

IGEMSection.propTypes = {
	children: node.isRequired,
};

export const IGEMTitle = ({ children }) => {
	return (
		<Heading Tag="h2" sx={{ fontSize: "xl", textAlign: "center" }}>
			{children}
		</Heading>
	);
};

IGEMTitle.propTypes = {
	children: node.isRequired,
};

export const IGEMPostWrapper = ({ children }) => {
	return (
		<Section>
			<Container>
				<Row utility={{ justify: "center" }}>
					<Col sm={12} md={11}>
						<Row mx utility={{ justify: "center" }}>
							{children}
						</Row>
					</Col>
				</Row>
			</Container>
		</Section>
	);
};

IGEMPostWrapper.propTypes = {
	children: node.isRequired,
};

export const IGEMPostItemWrapper = ({ children }) => {
	return (
		<Col sm={12} md={4} lg={3} sx={{ textAlign: "center" }} spacing={{ my: 10 }}>
			{children}
		</Col>
	);
};

IGEMPostItemWrapper.propTypes = {
	children: node.isRequired,
};

export const IGEMPostItemTitle = ({ children }) => {
	return (
		<Paragraph sx={{ fontSize: "m", fontWeight: "medium", fontColor: "2" }} className="min-h-12">
			{children}
		</Paragraph>
	);
};

IGEMPostItemTitle.propTypes = {
	children: node.isRequired,
};

export const IGEMPostImage = ({ src }) => {
	return <Image src={src} />;
};

IGEMPostImage.propTypes = {
	src: string.isRequired,
};

export const IGEMPostDescription = ({ children }) => {
	return <Paragraph>{children}</Paragraph>;
};

IGEMPostDescription.propTypes = {
	children: node.isRequired,
};

export const IGEMListSection = ({ children }) => {
	return (
		<Section spacing={{ mb: 10 }}>
			<Container>
				<Row utility={{ justify: "center" }} spacing={{ mt: 10 }}>
					<Col sm={12} md={11}>
						<Row>{children}</Row>
					</Col>
				</Row>
			</Container>
		</Section>
	);
};

IGEMListSection.propTypes = {
	children: node.isRequired,
};

export const IGEMListItemWrapper = ({ children }) => {
	return (
		<Col sm={12} md={4}>
			<ul>{children}</ul>
		</Col>
	);
};

IGEMListItemWrapper.propTypes = {
	children: node.isRequired,
};

export const IGEMListItem = ({ children }) => {
	return <li className="mb-3">{children}</li>;
};

IGEMListItem.propTypes = {
	children: node.isRequired,
};

export const IGEMImagesContainer = ({ children }) => {
	return (
		<Section spacing={{ mb: 20 }}>
			<Container>{children}</Container>
		</Section>
	);
};

IGEMImagesContainer.propTypes = {
	children: node.isRequired,
};

export const IGEMImagesRow = ({ children }) => {
	return (
		<Row mx my utility={{ justify: "center" }}>
			{children}
		</Row>
	);
};

IGEMImagesRow.propTypes = {
	children: node.isRequired,
};

export const IGEMImageCol = ({ children, className = "" }) => {
	return (
		<Col sm={12} md={4} lg={3} className={classes(className)}>
			{children}
		</Col>
	);
};

IGEMImageCol.propTypes = {
	children: node.isRequired,
	className: string,
};

export const IGEMImage = ({ src = "" }) => {
	return <Image src={src} className="width-100" />;
};

IGEMImage.propTypes = {
	src: string.isRequired,
};

export const ImageOverlayWrapper = ({ children }) => {
	return <div className="image-wrapper--text-block">{children}</div>;
};

ImageOverlayWrapper.propTypes = {
	children: node.isRequired,
};

export const ImageOverlayText = ({ children }) => {
	return <Paragraph sx={{ fontSize: "xs" }}>{children}</Paragraph>;
};

ImageOverlayText.propTypes = {
	children: node.isRequired,
};
